module.exports = __webpack_public_path__ + "static/antoinette-linton-5a86180d5aad4561bab3d50312b34917.jpg";